import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchDepartamentoData = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/departamento/${id}`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchDepartamentosData = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/departamentos`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
            'Cache-Control': 'no-cache'
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchNegociosData = async () => { 
    try {
        const response = await axios.get(`${API_URL}/api/negocios`, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};


export const fetchDepartamentosFiltersData = async (paginaActual, registrosPorPag, negocio, busqueda, ordenarColumna, orden, tipo) => {
    try {
        const response = await axios.post(`${API_URL}/api/departamentos/filters`, {

            "current_page": paginaActual,
            "items_per_page": registrosPorPag,
            "filteredWord": busqueda,
            "negocio": negocio,
            "tipo": tipo,
            "ordenarColumna": ordenarColumna || "",
            "orden": orden || ""

        }, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};


export const fetchCrearDepartamento = async (formData) => {
    console.log("formData_feeeee", formData);
    try {
        const response = await axios.post(`${API_URL}/api/departamento`, formData, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});
        
        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEditarDepartamento = async (departamentoData) => {
    try {
        const response = await axios.put(`${API_URL}/api/editarDepartamento/${departamentoData.Id}`, departamentoData, {headers: { 
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }});

        return response;
    } catch (error) {
        handleAuthError(error);
    }
};

export const fetchEliminarDepartamentos = async (ids) => {
    try {
        const idsArray = ids.toString().split(',');
        const promises = idsArray.map(id => axios.delete(`${API_URL}/api/departamento/${id}`, {
            headers: { 
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        }));
        const responses = await Promise.all(promises);
        const response = { data: responses.map(res => res.data) };

        return response.data;
    } catch (error) {
        handleAuthError(error);
    }
};